import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../../shared/shared.module';
import { BoatyardComponent } from './boatyard.component';
import { BoatyardRoutingModule } from './boatyard-routing.module';
import { BoatyardResolve } from './boatyard.resolve';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    BoatyardRoutingModule,
    MatDialogModule,
    MatIconModule,
    MatRadioModule,
  ],
  declarations: [BoatyardComponent],
  entryComponents: [],
  exports: [BoatyardComponent],
  providers: [BoatyardResolve],
})
export class BoatyardModule {}
